


if (document.querySelector('.wpcf7-form')) {
    const form = document.querySelector('.inquire-form .wpcf7-form');

    form.querySelectorAll('.input:not(.radio)').forEach((formField) => {

        let options = {
            childList: true,
            subtree:true
        },

        observer = new MutationObserver(mCallback);

        function mCallback(mutations) { // Mutation observer to listen for validation messages in child
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {

                    if (mutation.target.parentNode.querySelector('.wpcf7-not-valid-tip')){
                        mutation.target.parentNode.classList.add('invalid'); // Add invalid class to parent

                        mutation.target.querySelector('input').focus(); //Focus on input with error
                        let fieldName = mutation.target.querySelector('input').getAttribute('name'); //Get field name
                        mutation.target.querySelector('.wpcf7-not-valid-tip').setAttribute('id', "error-"+fieldName); //Use field name to add ID to error message
                        mutation.target.querySelector('input').setAttribute('aria-describedby', "error-"+fieldName); // aria describedby to error
                    }
                }
            }
        }

        observer.observe(formField, options);

        let input = null;

        if (formField.querySelector('input')) {
            input = formField.querySelector('input');
        }

        if (formField.querySelector('textarea')) {
            input = formField.querySelector('textarea');
        }

        if (input) {
            function inputChange() {
                formField.classList.add('changed');
            }

            function inputReset() {
                formField.classList.remove('changed');
            }

            input.addEventListener('change', () => {
                inputChange();
                if (input.value === '') {
                    inputReset();
                }
            });

            input.addEventListener('focusin', inputChange);
            input.addEventListener('focusout', () => {

                if (!formField.querySelector('.wpcf7-not-valid-tip')) { // Get rid of invalid styles
                    formField.classList.remove('invalid')
                }

                if (input.value === '') {
                    inputReset();
                }
            });
        }
    });

    if (document.querySelector('.wpcf7-response-output')) {
        const back = document.querySelector('.wpcf7-response-output');
    }

    form.addEventListener( 'wpcf7mailsent', () => {
        const formOuter = document.querySelector('.form');
        formOuter.classList.add('success');

        if(!document.querySelector('.page-en-espanol .inquire-form.success ')) {
            window.scrollTo(0, 0);
            document.querySelector('input[type="submit"]').disabled = true;
        }


        // Check if spanish form submitted successfully
        if(document.querySelector('.page-en-espanol .inquire-form.success ')) {
            setTimeout(() => {
                const formContainer = document.querySelector('.inquire-form');
                window.scroll(0, Position(formContainer));
                // console.log('form submitted');
            }, 200);
        }

        form.querySelectorAll('.input:not(.radio)').forEach((formField) => {
            formField.classList.remove('changed');
        });

        setTimeout(() => {
            formOuter.classList.remove('success');
            formOuter.classList.add('submitted');
            document.querySelector('input[type="submit"]').disabled = false;
        }, 11000)
    }, false );

    //Infinity tracking
    // _ictt.push(['_autoPopulateInput', {'id':'infinity_visitor_id', 'item':'ictvid'}]);
    // _its('setVariable','name','value')
    // _its.push(['_autoPopulateInput', {'id':'infinity_visitor_id', 'item':'ictvid'}]);
    // window._its.push(['_autoPopulateInput', {'id':'infinity_visitor_id', 'item':'ictvid'}]);


    //when the page is fully loaded, set the visitor id
    window.addEventListener('load', function() {
        set_visitor_id();
    });
}


function set_visitor_id() {
    window._its('autoPopulateInput', '#infinity_vid, input[name="infinity_vid"]');
    window._its('autoPopulateInput', '#custom6, input[name="custom6"]');
    // console.log('set_visitor_id');

}

function Position(obj){
    var currenttop = 0;
    if (obj.offsetParent){
        do{
            currenttop += obj.offsetTop;
        }while ((obj = obj.offsetParent));
        return [currenttop];
    }
}